export class WhatsAppTemplateMensagem {
  id: number = 0;
  guidclientenapis: string = "";
  nome: string = "";
  descricao: string = "";
  ativo: boolean = true;
  ordem: number = 0;
  data_atualizacao: Date = null;
  usuario_atualizacao: string = "";
  itens: WhatsAppTemplateMensagemItem[] = [];
  seller_ids: number[] = [];
}

export class WhatsAppTemplateMensagemItem {
  id: number = 0;
  template_id: number = 0;
  ordem: number = 0;
  /* TEXTO | IMAGEM | ARQUIVO | LINK | LISTA_OPCOES */
  tipo: string = "TEXTO";
  conteudo_texto: string = "";
  arquivo_url: string = null;
  arquivo_nome: string = null;
  arquivo_mime: string = null;
  link_url: string = "";
  link_texto: string = "";
  opcoes: WhatsAppTemplateOpcao[] = [];
  list_button: string = "";
  footer_text: string = "";
}

export class WhatsAppTemplateOpcao {
  titulo: string = "";
  id: string = "";
  descricao: string = "";
}

export class WhatsAppTemplateSeller {
  id: number = 0;
  fullname: string = "";
}

export class WhatsAppTemplateArquivoUploadResult {
  arquivo_url: string = "";
  arquivo_nome: string = "";
  arquivo_mime: string = "";
}
